import { createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader  } from '../../Shared/Loader/LoaderSlice';


export const getCustomerNvOrgListAsync = createAsyncThunk('businessMonitoringChartsBlock/getCustomerNvOrgListAsync', async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showAppLoader());
      const params = { searchKey: data?.searchKey };
      const result = await ProviderManager.getProviderData('getCustomerNvOrgList', params);
      return result?.Body;
    } catch (error) {
      
    } finally {
      thunkAPI.dispatch(hideAppLoader());
    }
});


export const getAdminNvOrgListAsync = createAsyncThunk('businessMonitoringChartsBlock/getAdminNvOrgListAsync', async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showAppLoader());
      const params = { 
        searchKey: data?.searchKey,
        searchType: data?.searchType
      };
      const result = await ProviderManager.getProviderData('getAdminNvOrgList', params);
      return result?.Body;
    } catch (error) {
      
    } finally {
      thunkAPI.dispatch(hideAppLoader());
    }
});


export const getChartListAsync = createAsyncThunk('businessMonitoringChartsBlock/getChartListAsync', async (data, thunkAPI) => {
    try {
        window.scrollTo(0, 0);

        thunkAPI.dispatch(showAppLoader());
        const state = thunkAPI.getState().businessMonitoringChartsBlock;

        const params = {
            userType: '1',
            nvId: data?.nvId,
            serviceCode: data?.serviceCode,
            resourceId: data?.resourceid,
            resName: data?.resourceid,
            ifName: data?.ifName,
            hostName: data?.hostName,    
            metric: data?.metric,
            resolution: data?.resolution,
            startDate: data?.startDate || '',
            endDate: data?.endDate || '',
            graphDataType: data?.graphDataType            
        };
        
        const methodName = (state.isAdminMode ? 'getAdminChartList' : 'getChartList');

        const result = await ProviderManager.getProviderData(methodName, params);
        return result?.Body;
    } catch (error) {
      
    } finally {
      thunkAPI.dispatch(hideAppLoader());
    }
});


export const getChartItemAsync = createAsyncThunk('businessMonitoringChartsBlock/getChartItemAsync', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const state = thunkAPI.getState().businessMonitoringChartsBlock;

        const params = {
            userType: '1',   
            nvId: data?.nvId,         
            serviceCode: data?.serviceCode,
            resourceId: data?.resourceid,  
            resName: data?.resourceid,
            ifName: data?.ifName,                      
            hostName: data?.hostName,    
            metric: data?.metric,
            resolution: data?.resolution,
            startDate: data?.startDate || '',
            endDate: data?.endDate || '',
            graphDataType: data?.graphDataType,
            graphId: data?.graphId
        };
      
        const methodName = (state.isAdminMode ? 'getAdminChartItem' : 'getChartItem');

        const result = await ProviderManager.getProviderData(methodName, params);
        return result?.Body;
    } catch (error) {
      
    } finally {
      thunkAPI.dispatch(hideAppLoader());
    }
});


export const updateServiceNameAsync = createAsyncThunk('businessMonitoringChartsBlock/updateServiceNameAsync', async (data, thunkAPI) => {
    try {
        //thunkAPI.dispatch(showAppLoader());

        const params = {  
            nvId: data?.nvId,         
            serviceCode: data?.serviceCode,            
            serviceName: data?.serviceName
        };
      
        const result = await ProviderManager.getProviderData('updateServiceName', params);
        return result?.Body;
    } catch (error) {
      
    } finally {
        //thunkAPI.dispatch(hideAppLoader());
    }
});


export const getFavoritesAsync = createAsyncThunk('businessMonitoringChartsBlock/getFavoritesAsync', async (data, thunkAPI) => {
    //TODO: get favorites charts and draw it on main page
});

  